import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useEffect, useState } from "react";


import PaginationComponent from "components/common/Pagination/index";
import {
  emptyPaginationObj,
  REPORTING_LIMIT,
  SORT_TYPE,
  getParticipantLabel,
} from "Constants/constant";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import { apiGetRequest, apiPostRequest } from "helpers/Requests";
import {
  URL_REPORTING_RISK_ASSSESSMENT_REPORTS,
  URL_REPORTING_RISK_CATEGORY_IN_RISK_ASSESSMENT_REPORTS,
} from "store/services/URL";
import moment from "moment";
import { toast } from "react-toastify";
import { addMonths, exportTOExcel } from "Utils/utils";
import useReportExport from "../useReportExport";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFilterSearchField,
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import { withReportSortOnUrl } from "../reportExportUtils";
import { Risk_Rating_Reporting } from "store/constants";
import RiskAssessmentSubTable from "./RiskAssessmentSubTable";

const RiskAssessmentReport = ({getTeamManagmentListCall,
  teamManagementList,
  getParticipantList,
  spParticipants, settings}) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const participantLabel = getParticipantLabel(settings?.care_sector, false);
  const participantNameLabel = `${participantLabel} Name`;
  const searchByParticipantLabel = `Search by ${participantNameLabel}`;
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(null);

  useEffect(() => {
    const filters = {
      page: 1,
      per_page: 500,
      search: null,
    };
    getParticipantList({ filters, bodyFilter: null });
    getTeamManagmentListCall({ filters, bodyFilter: null });
  }, []);

  const [workerList, setWorkerList] = useState([]);
  const [participantList, setParticipant] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [status, setStatus] = useState(null);

  const [search, setSearch] = useState(null);

  const [reportList, setReports] = useState(null);
  const [loader, setLoader] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isDisableSearch, setIsDisableSearch] = useState(false);
  const [expiryDate, setExpiryDate] = useState(null);
  const [riskRating, setRiskRating] = useState(null);
  const [riskCategory, setRiskCategories] = useState([]);
  const [selectedRiskCategory, setSelectedRiskCategory] = useState(null);

  useEffect(() => {
    if (!isInitialRender) {
      fetchListReports(false, null, {
        page,
        sort_field: sortBy,
        sort_order: sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
      });
    }
  }, [page]);

  useEffect(() => {
    const updateLists = async () => {
      const workers =
        teamManagementList?.employees?.data?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.uuid,
        })) || [];

      const sortedWorkers = workers.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      const participants =
        spParticipants?.participant?.data?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
        })) || [];

      const sortedParticipants = participants.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setParticipant([{ label: "All", value: "all" }, ...sortedParticipants]);
      setWorkerList([{ label: "All", value: "all" }, ...sortedWorkers]);
    };

    updateLists();
  }, [teamManagementList, spParticipants]);

  useEffect(() => {
    const getRiskCategories = async () => {
      try {
        const res = await apiGetRequest(
          URL_REPORTING_RISK_CATEGORY_IN_RISK_ASSESSMENT_REPORTS
        );

        if (res.status === 200) {
          const data = res.data?.data || [];
          const modifiedData = [
            { label: "All", value: "all" },
            ...data
              ?.map((item) => ({
                label: item.title,
                value: item.id,
              }))
              .sort((a, b) =>
                a.label.toLowerCase().localeCompare(b.label.toLowerCase())
              ),
          ];

          setRiskCategories(modifiedData);
        }
      } catch (error) {
        console.log({ error });
      }
    };

    getRiskCategories();
  }, []);

  const [isInitialRender, setIsInitialRender] = useState(true);
  const { runExport, QueuedModal, getExportSortFilters } = useReportExport(
    "risk_assessment_report",
    "Risk Assessment Report",
    { sortBy, sortDescending }
  );

  const fetchListReports = async (
    isClearAll = false,
    report = null,
    filters = {}
  ) => {
    if (!fromDate && !toDate) {
      toast("Select  date range to get data");
      return;
    }
    const currentPage = filters?.page || page;
    setLoader(true);
    let url = `${URL_REPORTING_RISK_ASSSESSMENT_REPORTS}?per_page=25&page=${currentPage}`;
    url = withReportSortOnUrl(url, filters, sortBy, sortDescending);
    const payload = {
      search: search ? search : "",
      participant: isClearAll
        ? "all"
        : selectedParticipant
        ? selectedParticipant?.value
        : "all",
      risk_owner: isClearAll
        ? "all"
        : selectedWorker
        ? selectedWorker?.value
        : "all",
      expiry_date: isClearAll ? "all" : expiryDate ? expiryDate : "all",
      risk_category: isClearAll
        ? "all"
        : selectedRiskCategory
        ? selectedRiskCategory?.value
        : "all",
      risk_migrated: isClearAll ? "all" : status ? status?.value : "all",
      submitted_date_range: isClearAll
        ? "all"
        : toDate && fromDate
        ? [fromDate, toDate]
        : "all",
      risk_rating: isClearAll ? "all" : riskRating ? riskRating?.value : "all",
    };
    if (report) {
      await runExport({
        format: report,
        payload,
        syncUrl: url,
        filters,
        totalRows: paginationObj?.total,
        setLoader,
        onSyncExcel: exportTOExcelFile,
        onSyncPdf: (downloadUrl) => window.open(downloadUrl, "_blank"),
      });
      return;
    }
    await apiPostRequest(url, payload)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          setReports(res?.data?.data);
          setPaginationObj((prev) => ({
            ...prev,
            total: res?.data?.data?.riskFormData?.total,
            totalPages: Math.ceil(
              res?.data?.data?.riskFormData?.total /
                res?.data?.data?.riskFormData?.per_page
            ),
          }));
        }
      })
      .catch((error) => {
        toast.error(`${error}`);
        console.log({ error });
        setLoader(false);
      });
  };
  const handleFileDownLoad = (e) => {
    fetchListReports(false, e, getExportSortFilters());
  };
  const handleCancelButton = () => {
    setExpiryDate(null);
  };
  const handleSearch = () => {
    setPage(1);

    const updatedPaginationObj = { ...paginationObj, page: 1 };
    setPaginationObj(updatedPaginationObj);

    fetchListReports(false, null, {
      page: 1,
      sort_field: sortBy,
      sort_order: sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  const handleClearFilters = () => {
    setStatus(null);
    setSelectedWorker(null);
    setFromDate(null);
    setToDate(null);
    setSearch(null);
    setSelectedRiskCategory(null);
    setRiskRating(null);
    setExpiryDate(null);
    setReports([]);
    setSelectedFromDate(null);
    setSelectedParticipant(null);
  };

  const exportTOExcelFile = (reportData) => {
    // const transformedData =
    //   reportData &&
    //   reportData.riskFormData &&
    //   reportData?.riskFormData?.flatMap((item) => {
    //     if (item.template && item?.template?.length > 0) {
    //       return item?.template?.map((el) => {
    //         return {
    //           Participant: item?.participant_name || "N/A",
    //           Risk_Category: item?.title || "N/A",

    //           Created_By: item?.created_by || "N/A",
    //           Submitted_Date: item?.created_at || "N/A",
    //           Last_Updated_By: item?.updated_by || "N/A",
    //           Last_Updated_Date: item?.updated_at || "N/A",
    //           Expiry_Date: item?.service_category?.name || "N/A",
    //           Risk_Assessed_Questions: el?.question || "N/A",
    //           Status:
    //             (el?.mitigation_strategy_data &&
    //               el?.mitigation_strategy_data?.risk_migration_status) ||
    //             "N/A",
    //           Risk_Rating: el?.risk_rating || "N/A",
    //           Risk_Owner:
    //             (el?.mitigation_strategy_data &&
    //               el?.mitigation_strategy_data?.risk_owner) ||
    //             "N/A",
    //           Mitigation_Date:
    //             el?.mitigation_strategy_data &&
    //             el?.mitigation_strategy_data?.risk_migration_status
    //               ? moment(
    //                   el?.mitigation_strategy_data?.risk_migration_status
    //                 ).format("DD/MM/YYYY")
    //               : "N/A",
    //           Mitigation_Strategy:
    //             (el?.mitigation_strategy_data &&
    //               el?.mitigation_strategy_data?.risk_migration_strategy) ||
    //             "N/A",
    //         };
    //       });
    //     } else {
    //       return [];
    //     }
    //   });

    const transformedData =
      reportData &&
      reportData.riskFormData &&
      reportData?.riskFormData?.flatMap((item) => {
        if (item.template && item.template?.length > 0) {
          return item.template.map((el) => {
            return {
              [participantLabel]: item?.participant_name || "N/A",
              Risk_Category: item?.title || "N/A",
              Created_By: item?.created_by || "N/A",
              Submitted_Date: item?.created_at || "N/A",
              Last_Updated_By: item?.updated_by || "N/A",
              Last_Updated_Date: item?.updated_at || "N/A",
              Expiry_Date: item?.expiry_date || "N/A",
              Risk_Assessed_Questions: el?.question || "N/A",
              // Status:
              //   (el?.mitigation_strategy_data &&
              //     el?.mitigation_strategy_data?.risk_migration_status) ||
              //   "N/A",
              Status: el?.mitigation_strategy_data
                ? el?.mitigation_strategy_data?.risk_migration_status
                  ? "Closed"
                  : "Mitigation Strategy"
                : "Open",
              Risk_Rating: el?.risk_rating || "N/A",
              Risk_Owner:
                (el?.mitigation_strategy_data &&
                  el?.mitigation_strategy_data?.risk_owner) ||
                "N/A",
              Mitigation_Date:
                el?.mitigation_strategy_data &&
                el?.mitigation_strategy_data?.risk_migration_strategy_date
                  ? moment(
                      el?.mitigation_strategy_data?.risk_migration_strategy_date
                    ).format("DD/MM/YYYY")
                  : "N/A",
              Mitigation_Strategy:
                (el?.mitigation_strategy_data &&
                  el?.mitigation_strategy_data?.risk_migration_strategy) ||
                "N/A",
            };
          });
        } else {
          return [
            {
              [participantLabel]: item?.participant_name || "N/A",
              Risk_Category: item?.title || "N/A",
              Created_By: item?.created_by || "N/A",
              Submitted_Date: item?.created_at || "N/A",
              Last_Updated_By: item?.updated_by || "N/A",
              Last_Updated_Date: item?.updated_at || "N/A",
              Expiry_Date: item?.expiry_date || "N/A",
              Risk_Assessed_Questions: "N/A",
              Status: "N/A",
              Risk_Rating: "N/A",
              Risk_Owner: "N/A",
              Mitigation_Date: "N/A",
              Mitigation_Strategy: "N/A",
            },
          ];
        }
      });

    if (
      !transformedData ||
      transformedData === undefined ||
      transformedData?.length === 0
    ) {
      toast("No data found!");
      return;
    }

    exportTOExcel(transformedData);
  };

  const handleFetch = (obj) => {
    fetchListReports(false, null, { ...obj });
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='Risk Assessment Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.RISK_ASSESSMENT_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={4}>
                <ReportFilterField label={participantNameLabel}>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='pt_id'
                    isSearch={true}
                    data={participantList || []}
                    selectedOption={selectedParticipant}
                    handleChange={(e) => setSelectedParticipant(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Risk Category'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='worker_id'
                    isSearch={true}
                    data={riskCategory || []}
                    selectedOption={selectedRiskCategory}
                    handleChange={(e) => setSelectedRiskCategory(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Submitted Date Range(Max 3 Months)' required>
                  <DateRangePickerNew
                    handleCancel={() => {
                      setFromDate(null);
                      setToDate(null);
                      setReports([]);
                    }}
                    handleChange={(obj) => {
                      if (obj && obj.fromDate && obj.toDate) {
                        obj.fromDate && setFromDate(obj.fromDate);
                        obj.toDate && setToDate(obj.toDate);
                      }
                    }}
                    setSelectedFromDate={setSelectedFromDate}
                    fromDate={fromDate}
                    toDate={toDate}
                    maxDate={addMonths(selectedFromDate, 3)}
                    setIsDisableSearch={setIsDisableSearch}
                  />
                </ReportFilterField>
                <ReportFilterField label='Expiry Date'>
                  <DateRangePickerNew
                    isSingleDate
                    isClearable
                    handleCancel={handleCancelButton}
                    handleChange={(obj) => setExpiryDate(obj)}
                    singleSelectedDate={expiryDate && new Date(expiryDate)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Status'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='status'
                    isSearch={true}
                    data={[
                      { label: "All", value: "all" },
                      { label: "Yes", value: true },
                      { label: "No", value: false },
                    ]}
                    handleChange={(e) => setStatus(e)}
                    selectedOption={status}
                  />
                </ReportFilterField>
                <ReportFilterField label='Risk Rating'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='overtime'
                    isSearch={true}
                    data={Risk_Rating_Reporting || []}
                    selectedOption={riskRating}
                    handleChange={(e) => setRiskRating(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Risk Owner'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='overtime'
                    isSearch={true}
                    data={workerList || []}
                    selectedOption={selectedWorker}
                    handleChange={(e) => setSelectedWorker(e)}
                  />
                </ReportFilterField>
                <ReportFilterSearchField
                  label={searchByParticipantLabel}
                  search={search}
                  setSearch={setSearch}
                  onSearch={handleSearch}
                  placeholder={searchByParticipantLabel}
                />
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={handleFileDownLoad}
                isLoading={loader}
                isSearchDisabled={isDisableSearch}
                isUserGracePeriodOver={isUserGracePeriodOver}
              />
            </ReportFiltersShell>
            <ReportTableSection>
                <table className='border min-w-full divide-y divide-gray-300'>
                  <thead
                    // style={{ top: "130px" }}
                    className='bg-gray-50 sticky z-[5]'
                  >
                    <tr>
                      <TableHeader isSort={false} label={""}  cssClass='bg-blue-50 pl-4' />

                      <TableHeader isSort={false} label={participantLabel} cssClass='bg-blue-50'/>

                      <TableHeader isSort={false} label={"Risk Category"} cssClass='bg-blue-50' />

                      <TableHeader isSort={false} label={"Created By"}cssClass='bg-blue-50'  />
                      <TableHeader
                        sortName='created_at'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Submitted Date "}
                        cssClass='bg-blue-50'
                      />

                      <TableHeader isSort={false} label={"Last Updated By"} cssClass='bg-blue-50' />
                      <TableHeader
                        sortName='updated_at '
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Last Updated date"}
                        cssClass='bg-blue-50'
                      />
                      <TableHeader isSort={false} label={"Expiry Date"} cssClass='bg-blue-50' />
                    </tr>
                  </thead>
                  <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
                    {loader ? (
                      <tr className='bg-white'>
                        <td colSpan={8} className='py-6 text-center bg-white'>
                          <div
                            className={`flex flex-col w-full min-h-screen  items-center justify-start`}
                          >
                            <CircularLoader
                              classes='flex justify-center items-center'
                              classloader='loader-l'
                            />
                          </div>
                        </td>
                      </tr>
                    ) : reportList !== null &&
                      reportList?.riskFormData?.data?.length > 0 ? (
                      reportList?.riskFormData?.data?.map((item, index) => (
                        <RiskAssessmentSubTable item={item} key={index} />
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={8}
                          className='py-6 text-center text-red-600'
                        >
                          No data found. Please adjust your filters to get
                          relevant results
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
            </ReportTableSection>

              {reportList && reportList?.riskFormData?.data?.length > 0 && (
                <div className='mt-3'>
                  <PaginationComponent
                    page={paginationObj?.page || 1}
                    activeListLength={reportList?.riskFormData?.data || []}
                    limit={REPORTING_LIMIT}
                    totalList={paginationObj?.total}
                    handlePagination={(e) => {
                      setPage(e);
                      const obj = paginationObj;
                      obj.page = e;
                      setPaginationObj({ ...obj });
                      fetchListReports(false, null, {
                        page: e,
                        sort_field: sortBy,
                        sort_order: sortDescending
                          ? SORT_TYPE.DESC
                          : SORT_TYPE.ASC,
                      });
                    }}
                    totalPages={paginationObj?.totalPages}
                  />
                </div>
              )}
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default RiskAssessmentReport;
